import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c0b3d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = ["srcset", "media"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]

import { PropType } from "@vue/runtime-core";

export type ImageProps = {
  alt: string,
  url: string
  double?: string
  mobile?: {
    url: string
    double?: string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UIImage',
  props: {
  image: {
    type: Object as PropType<ImageProps>,
    default: null
  },
  mobileBreak: {
    type: Number,
    default: 1050
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", {
    class: "UIImage",
    alt: __props.image?.alt
  }, [
    (__props.image?.mobile)
      ? (_openBlock(), _createElementBlock("source", {
          key: 0,
          srcset: `${__props.image?.mobile.url} 1x, ${__props.image?.mobile.double || __props.image?.mobile.url} 2x`,
          media: `(max-width: ${__props.mobileBreak}px)`
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("source", {
      srcset: `${__props.image?.url} 1x, ${__props.image?.double || __props.image?.url} 2x`
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      src: __props.image?.url
    }, null, 8, _hoisted_4)
  ], 8, _hoisted_1))
}
}

})